import { render, staticRenderFns } from "./EditCommunityAdministratorsModal.vue?vue&type=template&id=d1d6a96c&scoped=true&"
import script from "./EditCommunityAdministratorsModal.vue?vue&type=script&lang=ts&"
export * from "./EditCommunityAdministratorsModal.vue?vue&type=script&lang=ts&"
import style0 from "./EditCommunityAdministratorsModal.vue?vue&type=style&index=0&id=d1d6a96c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1d6a96c",
  null
  
)

export default component.exports